import MonitoringQueueTableDropdown from './MonitoringQueueTableDropdown';

export default MonitoringQueueTableDropdown;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/searching/search-form/table/dropdown/index.js